module.exports = "/images/Salesforce.svg?9844eaf24d1a20766d2339d60c932fae";